import React from "react";
import Todo from "./components/Todo";
import "./App.css";

const App = () => {
  return (
    <div className="app component">
      <div className="component-container">
        <Todo />
      </div>
    </div>
  );
};

export default App;
